<template>
  <div class="cb" v-if="kbxmlc">
    <!-- 多次报价中 -->
    <template v-if='dcbjjssj&& role == "Z"'>
      <div class="bjBtn">
        <p>报价剩余时间</p>
        <myClock
          :shenyu="dcbjjssj"
          :key="dcbjjssj"
          cId="c1"
        ></myClock>
        <!-- <p class='total'>共{{tbdwsl}}家，已报价{{tbdwyxgsl}}家，待报价{{tbdwwxgsl}}家。</p> -->
        <p class='total'>有效投标家数{{tbdwsl}}家，已报价{{tbdwyxgsl}}家。</p>
      </div>
      <el-button
        type="primary lcNext"
        @click="stopBj"
        >结束报价</el-button>
    </template>
    <template v-else>
      <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
        <div class="clear">
          <p class="cont-title lf">唱标</p>
          <div class="rt">
            <el-input
              v-model="tbdwmc"
              class="input-with-select lf"
              style="width: 250px; margin: 0 10px"
              placeholder="投标单位名称"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getData"
              ></el-button>
            </el-input>
            <draw-bid-concession-rate @close="getData" :hide-tip="true" style="display: inline-block; margin-right: 10px;"></draw-bid-concession-rate>
            <template v-if="role == 'Z'">
              <!-- <el-button
                type="primary"
                @click="openBj"
                :disabled='!dcbjzt||kbxmlc.zt==2'
                >开启多轮报价</el-button
              > -->
              <el-button
                type="primary"
                @click="setCs"
                v-if="sfycs && ispublishAll != 1 && ispublishAll != 2"
                >参数设置</el-button
              >
            </template>
          </div>
        </div>
        <p
          class="red"
          style="padding-bottom: 10px"
          v-if="sfycs && ispublishAll != 1 && ispublishAll != 2"
        >
          <span v-if="newTips">
            {{ newTips }}
          </span>
          <span v-else>
            {{
              role == "Z" ? "请按招标文件要求设置参数" : "请等待设置参数"
            }}
          </span>
        </p>
        <template v-if="ispublishAll == 1">
          <!-- 公布了 -->
          <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            max-height="570"
          >
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column
              prop="qymc"
              label="投标单位名称"
              show-overflow-tooltip
              min-width="180"
            ></el-table-column>
            <el-table-column
              width="140"
              show-overflow-tooltip
              v-for="(item, index) in priceAry"
              :key="index"
              :label="item.bjcsmc"
            >
              <template slot-scope="scope">
                {{ scope.row.cgkbdcbjList[index].bjje }}
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-else-if="ispublishAll == 2">
          <!-- 不公布了 -->
          <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            max-height="570"
          >
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column
              prop="qymc"
              label="投标单位名称"
              show-overflow-tooltip
              min-width="180"
            ></el-table-column>
            <el-table-column
              width="140"
              show-overflow-tooltip
              label="总报价（元）"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.cgkbdcbjList && scope.row.cgkbdcbjList.length > 1
                  "
                >
                  {{
                    scope.row.cgkbdcbjList[scope.row.cgkbdcbjList.length - 1].bjje
                  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-else>
          <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            max-height="570"
            :highlight-current-row="true"
          >
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column
              prop="fcqymc"
              label="投标单位名称"
              show-overflow-tooltip
              min-width="180"
            ></el-table-column>
            <el-table-column
              :prop="val"
              :label="key"
              width="150"
              v-for="(val, key, index) in tableHead"
              :key="index"
              show-overflow-tooltip
            >
            </el-table-column>
            <!-- <el-table-column  label="操作"  width="60" fixed='right'>
                      <template slot-scope="scope">
                          <el-button  type="text" @click='lookXq(scope.row)'>详情</el-button>
                      </template>
                  </el-table-column> -->
          </el-table>
        </template>
        <div class="clear">
          <span class="lf pageNum">共{{ total }}家。</span>
        </div>
      </div>
      <el-button
        type="primary lcNext"
        @click="nextBtn"
        v-if="kbxmlc.zt != '2' && role == 'Z'"
        :disabled="waitLoading"
        >下一步</el-button>
    </template>
    <!-- 设置报价时间 -->
    <el-dialog
      title="开启多轮报价"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <div style="margin-bottom:50px;">
          <span>报价倒计时设置 </span>
          <el-input
            type="number"
            v-model.number="time"
            style="width: 120px"
          ></el-input>
          分钟
        </div>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveBjTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 设置参数 -->
    <el-dialog
      title="设置参数"
      :visible.sync="dialogFormVisible"
      width="580px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form" label-width="285px" :disabled="!canSet">
        <el-form-item
          :label="item.csmc"
          v-for="(item, index) in formItem"
          :key="index"
          :prop="item.csdm"
          :rules="
            /^[a-z]$/g.test(item.csdm)
              ? [{ validator: validateFieldMethods, trigger: 'blur' }]
              : [{ required: true, message: '必填项', trigger: 'blur' }]
          "
        >
          <!-- <el-input oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g, '')"  v-model="form[item.csdm]" style='width:300px'></el-input> {{item.cshz}} -->
          <template v-if="objectType == 1">
            <el-select
            v-if="item.yzgz == 'select'"
              v-model="form[item.csdm]"
              style="width: 150px"
            >
            <el-option 
            v-for="a in item.urldz.split(',')"
            :key="a" 
            :label="a" 
            :value="a"></el-option>
            </el-select>
            <el-input
              v-else
              oninput="value=value.replace(/[^\d\.\-0]/g,'').replace(/^\./g, '')"
              v-model="form[item.csdm]"
              style="width: 150px"
            ></el-input>
          </template>
          
          <template v-else>
            <el-select
            v-if="item.yzgz == 'select'"
              v-model="form[item.csdm]"
              style="width: 150px"
            >
            <el-option 
            v-for="a in item.urldz.split(',')"
            :key="a" 
            :label="a" 
            :value="a"></el-option>
            </el-select>
            <el-input
              v-else
              v-model="form[item.csdm]"
              :disabled="item.abled"
              @input="defaultValue(item.csdm, form[item.csdm], item.ball)"
              style="width: 150px"
            ></el-input>
          </template>
          {{ item.cshz }}
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button
          v-if="canSet"
          type="primary"
          @click="saveForm('form')"
          :disabled="waitLoading"
          >确定</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="dialogFormVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myClock from "../components/clock/clock";
import ParamSettingMixin from '@/mixins/ParamSettingMixin';
import DrawBidConcessionRate from '@/components/draw/drawBidConcessionRate'

export default {
  name: "cb",
  components: { myClock, DrawBidConcessionRate },
  mixins: [ParamSettingMixin],
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", // 当前节点状态
      sfycs: true,
      tableHead: {},
      tableData: [],
      tbdwmc: "",
      isOk: false, // 是否可以下一步
      csjg: [], // 是否已经设置过参数
      dialogFormVisible: false, //设置参数
      formItem: [],
      form: {},
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      ispublishAll: '',
      priceAry: [],
      objectType: "", //项目大类1、采购项目 2、工程项目
      setCsdm: "",
      setCqs: "",
      setBall: "",
      dialogVisible:false,//设置报价时间弹窗
      time:"",
      dcbjzt:true,//多次报价按钮是否可点击
      bjTime:'',
      intervalBj:null,//报价定时器
      dcbjjssj:null,
      tbdwsl:NaN,
      tbdwyxgsl:NaN,
      tbdwwxgsl:NaN
    };
  },
  methods: {
    // ------------2021-10-26新增
    async publish() {
      let para = {};
      para.djlcId = this.djlcId;
      //    para.djlcId = "投标谢大帅";
      try {
        let res = await this.$api.ispublish(para);
        if (res.status == 200) {
          this.ispublishAll = res.data.data.isPublish;
          res.data.data.dcbj.forEach((ele, index) => {
            this.priceAry = [...ele.cgkbdcbjList];
          });
          this.total = res.data.data.total;
          this.tableData = res.data.data.dcbj;
          this.kbxmlc = res.data.data.kbxmlc;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log("投标人", err);
      }
    },
    // ---------------
    changeInp(name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, ""); //清除非 数字和小数点的字符
      this.form[name] = this.form[name].replace(/\.{2,}/g, "."); //清除第二个小数点
      this.form[name] = this.form[name].replace(/^\./g, ""); //验证第一个字符是数字而不是字符
      this.form[name] = this.form[name]
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.form[name] = this.form[name].replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      ); //保留两位小数
      this.form[name] =
        this.form[name].indexOf(".") > 0
          ? this.form[name].split(".")[0].substring(0, 5) +
            "." +
            this.form[name].split(".")[1]
          : this.form[name].substring(0, 5); //限制只能输入7位正整数
    },
    getData() {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.kbxmlc=null;
      this.dcbjjssj=null
      this.bjTime=null;
      clearTimeout(this.intervalBj);
      this.intervalBj = null;
      this.$api
        .getCbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableHead = res.data.data.bjxsmc;
            this.kbxmlc = res.data.data.kbxmlc;
            this.total = res.data.data.data.total;
            //this.csjg = res.data.data.csList;
            this.sfycs = res.data.data.sfycs;
            this.newTips = res.data.data.cscqStr; // 张焱新增字段 2021/12/15
            this.dcbjzt=res.data.data.dcbjzt;//多次报价按钮是否可点击
            var dcbjjssj=res.data.data.dcbjjssj;
            this.tbdwsl=res.data.data.tbdwsl
            this.tbdwyxgsl=res.data.data.tbdwyxgsl
            this.tbdwwxgsl=res.data.data.tbdwwxgsl
            if(dcbjjssj){
              var nowTime=new Date().getTime();
              if(dcbjjssj-nowTime>= 1000){
                this.dcbjjssj=dcbjjssj-nowTime;
                this.bjTime = this.dcbjjssj;
                this.bjshenyuFun()
              }
            }
            
            if (res.data.data.tbdwMap) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in res.data.data.tbdwMap[item.id]) {
                  item[key] = res.data.data.tbdwMap[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
            this.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          console.log(this.dcbjzt)
          console.log(this.kbxmlc.zt)
        })
        .catch(() => {});
    },
    //开启多轮报价
    openBj(){
      this.time = 5;
      this.dialogVisible=true
    },
    //确认报价时间
    saveBjTime() {
      let para = {
        dcbjsj: this.time,
      };
      this.waitLoading = true;
      this.$api
        .kqdcbj(para)
        .then((res) => {
          if (res.data.meta.success) {
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.dialogVisible = false;
            this.waitLoading = false;
            this.getData(1);
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //结束报价
    stopBj(){
      this.waitLoading = true;
      this.$api
        .gbdcbj()
        .then((res) => {
          if (res.data.meta.success) {
            clearTimeout(this.intervalJm);
            this.intervalJm = null;
            this.getData(1);
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
            this.waitLoading = false;
          } else {
            this.waitLoading = false;
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
        })
        .catch(() => {});
    },
    //设置参数
    setCs() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .getKbxmCscqnrForm(para)
        .then((res) => {
          this.waitLoading = false;
          if (res.data.meta.success) {
            if (res.data.data.kcList.length) {
              this.formItem = res.data.data.kcList;
              this.formItem.forEach((item) => {
                let reg = /^[a-z][z]$/g;
                let reg2 = /^[a-z]$/g;
                if (reg.test(item.csdm)) {
                  item.abled = true;
                } else {
                  item.abled = false;
                }
                if (reg2.test(item.csdm)) {
                  item.ball = 1; // 是选球
                } else {
                  item.ball = 0; // 不是选球
                }
              });
              if (res.data.data.csMap) {
                this.form = Object.assign({}, res.data.data.csMap);
              }
              this.dialogFormVisible = true;
            } else {
              this.$message({
                type: "warning",
                message: "无需设置参数",
              });
            }
          }
        })
        .catch(() => {});
    },
    defaultValue(csdm, cqs, ball) {
      this.form[csdm] = this.form[csdm]
        .replace(/[^\d\.\-0]/g, "")
        .replace(/^\./g, "");
      this.setCsdm = csdm;
      this.setCqs = cqs;
      this.setBall = ball;
      // this.validateFrom[csdm] == "";
    },
    changeBallNum(csdm, cqs, ball) {
      // this.waitLoading = true;
      if (ball != 1) return;
      let para = {
        csdm,
        cqs,
      };
      return this.$api
        .hqcqz(para)
        .then((res) => {
          // this.waitLoading = false;
          if (res.data.data == 999) {
            this.form[csdm] = "";
            return 1;
          }
          this.form[csdm + "z"] = res.data.data;
          return 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async validateFieldMethods(rule, value, callback) {
      if (!value) {
        callback(new Error("必填项"));
      } else {
        // if (this.validateFrom[this.setCsdm] == 0) {
        //   callback();
        // } else {
        let text = await this.changeBallNum(
          this.setCsdm,
          this.setCqs,
          this.setBall
        );
        if (text == 1) {
          callback(new Error("请输入正确的球号！"));
        } else {
          // this.validateFrom[this.setCsdm] = text;
          callback();
          // }
        }
      }
    },
    //保存参数设置
    saveForm(formName) {
      this.$refs[formName].validate((valide) => {
        if (valide) {
          this.waitLoading = true;
          this.dialogFormVisible = false;
          let para = this.form;
          this.$api
            .saveSzcs(para)
            .then((res) => {
              if (res.data.meta.success) {
                if (this.objectType == "2") {
                  this.getData();
                }
                let obj = {
                  lx: "zb",
                  data: {
                    id: "",
                  },
                };
                this.$emit("send", JSON.stringify(obj));
                this.getData()
              } else {
                this.$message({
                  type: "error",
                  message: res.data.meta.message,
                });
              }
              this.waitLoading = false;
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //查看投标单位多清单
    lookXq(row) {},
    nextBtn() {
      this.waitLoading = true;
      this.$api
        .checkCqz()
        .then((res) => {
          if (res.data.meta.success) {
            let para = {
              flag: this.kbxmlc.ycdz,
            };
            this.waitLoading = true;
            this.$emit("nextBtn", para);
          } else {
            this.waitLoading = false;
            this.$message({
              type: "warning",
              message: res.data.meta.message,
            });
          }
        })
        .catch((err) => {
          this.waitLoading = false;
          this.$message({
            type: "warning",
            message: err.data.meta.message,
          })
        })
    },
    async initData() {
      let type = await this.getFileType();
      this.objectType = type;
      //项目大类1、采购项目 2、工程项目
      if (type == "1") {
        // 还得区分是否是多次报价的项目
        this.publish();
      } else {
        console.log("type", type);
      }
      if (this.ispublishAll != 1 && this.ispublishAll != 2) {
        this.getData();
      }
    },
    getFileType() {
      return this.$api
        .judgeType()
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //计算剩余时间倒计时
    bjshenyuFun() {
      var _this = this;
      _this.intervalBj = setTimeout(function () {
        _this.bjTime = _this.bjTime - 1000;
        if (_this.bjTime < 1000) {
          clearTimeout(_this.intervalBj);
          _this.intervalBj = null;
          _this.getData(22);
          return false;
        } else {
          _this.bjshenyuFun();
        }
      }, 1000);
    },
  },

  created() {
    this.djlcId = this.$route.query.djlcId;
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.cb {
  .cont-title {
    span {
      font-size: 14px;
      font-weight: normal;
      margin-left: 5px;
    }
  }
  .bjBtn{
    border: 1px solid rgba(0, 96, 178, 0.1);
    border-top: 2px solid #0060b2;
    text-align: center;
    height: calc(100% - 60px);
    padding-top: 80px;
    >p{
      font-size: 20px;
      color: #2D2D2D;
    }
    >p.total{
      font-size: 16px;
      color: #333333;
    }
    .clock{
    }
  }
}
</style>